import { CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import leadActivityServices from '../leadActivityServices';


import { Forum, PinDrop } from '@mui/icons-material';
import LeadActivityTimeline from './LeadActivityTimeline';

function LeadActivityList({leadId = 0}) {
    const [activityList,setActivityList] = useState(null);
    const [loading,setLoadingStatus] = useState(false);

    const getActivityList = () =>{
        setLoadingStatus(true);
        leadActivityServices.getByLeadId(leadId).then(res=>{
            setActivityList(res.data);
            console.log(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getAllActivityList = () =>{
        setLoadingStatus(true);
        leadActivityServices.getList().then(res=>{
            setActivityList(res.data);
            console.log(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    
    useEffect(()=>{
        if(leadId === 0){
            getAllActivityList()
        } else {
            getActivityList();
        }
        
    },[leadId])


    const [filteredList,setFilteredList] = useState(null);

    const [activeFilter,setActiveFilter] = useState("Remark");

    useEffect(() => {
        if (activityList) {
            // Step 1: Filter by Project (if ID is provided)
            let filtered = [...activityList];

            // Step 2: Apply Status/Priority Filters
            if (activeFilter === 'Remark') {
                filtered = filtered.filter(activity => activity.activityType === "Remark");
            } else if (activeFilter === 'all') {
                filtered = filtered;
            } 

            setFilteredList(filtered);
        }
    }, [activityList, activeFilter]);
    

    return (
    <>
            <div className='row' >
                <div className='col-md-12'>
                    <ul className="nav nav-pills nav-fill">
                        <li className="nav-item">
                            <button 
                                onClick={()=>setActiveFilter("Remark")} 
                                className={activeFilter === "Remark" ? "nav-link active" : "nav-link"}
                            ><Forum/>Remarks</button>
                        </li>
                        
                        <li className="nav-item">
                            <button 
                                onClick={()=>setActiveFilter("all")} 
                                className={activeFilter === "all" ? "nav-link active" : "nav-link"}
                            > All</button>
                        </li>
                        
                    </ul>
                </div>
            </div>
            {loading && <div className='text-center p-5'><CircularProgress/></div>}
            {!loading && filteredList &&
                <LeadActivityTimeline data={filteredList} />
            }
    </>
    )
}

export default LeadActivityList